// extracted by mini-css-extract-plugin
export var cartContainer = "_pr-4";
export var gray = "_pr-1";
export var itemContainer = "_pr-2";
export var itemDetails = "_pr-3";
export var strong = "_pr-0";